import regeneratorRuntime from "regenerator-runtime";

class TippyContentInvoker {
  constructor(phxComponent) {
    this._phxComponent = phxComponent
    this._target = this._phxComponent.el.querySelector('[js-id=action-button]')
    this._target.addEventListener('click', () => {
      if (this._isInitialized === true) {
        this._tippyInstance.show()
      } else {
        this._init()
      }
    })
  }

  _init() {
    this.getComponents().then( (tippy) => {
      let template = this._phxComponent.el.querySelector('.actions-list')
      const instance = tippy(this._target, {
        content: template.innerHTML,
        allowHTML: true,
        placement: 'top',
        trigger: 'manual',
        animation: 'perspective',
        interactive: true,
        arrow: true,
        offset: [0, 0],
        zIndex: 40,
        maxWidth: 350,
      });
      this._tippyInstance = instance
      this._tippyInstance.show()
      this._isInitialized = true
    })
  }

  destroy() {
    if (this._tippyInstance)
      this._tippyInstance.destroy()
    this._isInitialized = false
  }

  async getComponents() {
    const {default: tippy} = await import('tippy.js')
    await import('tippy.js/dist/tippy.css')
    await import('tippy.js/animations/perspective.css')
    return tippy
  }
}

const TippyContent = {
  mounted(){
    this._tippyContent = new TippyContentInvoker(this)
    console.log('PopperContent mounted')
  },
  disconnected() { console.log('PopperContent disconnected') },
  reconnected()  { console.log('PopperContent reconnected') },
  updated() {
    console.log('PopperContent updated')
    this._tippyContent.destroy()
  },
  destroyed()    {
    this._tippyContent.destroy()
    console.log('PopperContent destroyed')
  }
}

export default { TippyContent };
